import React from 'react';
import NavbarOne from './separate/NavbarOne';
import Buycrypto from './Buycrypto';
import SellCryptoPro from './SellCryptoPro';
import PageTitleDes from '../core/support/PageTitleDes';

const InstaTrade = (props) => {
    const [tab, setTab] = React.useState(true);
    return (
        <div className='bg-default  text-white  pb-3' style={{ minHeight: '100vh' }}>
            <PageTitleDes title={`Instant Crypto Trading | Quick Buy & Sell Crypto`} description={`Buy and sell cryptocurrencies instantly with our easy-to-use trading feature. Fast, simple, and secure transactions.`} />
            <NavbarOne
                setTheme={props.setTheme}
                theme={props.theme}
            /><section >

                <div className='container pt-5'>
                    <div>
                        <div className='tab-trade mx-auto'>
                            <button className={`${tab ? 'btn-trade' : 'btn-false'}`} onClick={() => {
                                setTab(true);
                            }} type='button'>BUY</button>
                            <button className={`${tab ? 'btn-false' : 'btn-trade-sell'}`} style={{ background: tab ? '' : '#dc3545' }} onClick={() => setTab(false)} type='button'>SELL</button>
                        </div>
                    </div>
                    {
                        tab ? <Buycrypto /> : <SellCryptoPro />
                    }
                </div>
            </section>
        </div>

    );
};

export default InstaTrade;